@use "@design/design-tokens/typography/typography" as *;
@use "../table-primitives" as *;

@layer design-system {
  .tableCell {
    font-family: var(--font-nort);
    @include typography-v2-body-sm;
    border-bottom: 1px solid var(--border-soft);
    background-color: var(--background-default);
    white-space: nowrap;
    padding: 12px;

    &.isNumber {
      font-family: var(--font-roboto-mono);
    }

    &.isUpperCase {
      text-transform: uppercase;
    }

    &.positive {
      color: var(--text-success);
    }

    &.critical {
      color: var(--text-critical);
    }

    &.fixed {
      @include fixed-table-cell;
    }

    &.condensed {
      @include typography-v2-body-xs;
      padding: 4px 12px;
    }

    &.pinned {
      position: sticky;
      z-index: var(--z-index-table-cell);
    }

    &.lastPinned {
      border-right: 1px solid var(--border-default);
    }
  }
}
